module.exports = __webpack_public_path__ + "static/img/kaishichoujiang.feff86ad.png";